import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../hooks/useAuthContext';
import axios from 'axios';
import OrganizationList from '../components/OrganizationList';
import PetList from '../components/PetList';
import { BsFillHouseAddFill } from 'react-icons/bs';
import { MdOutlinePets } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import '../style/Home.css';

const Home = () => {
    const { user } = useAuthContext();
    const { t } = useTranslation();
    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchOrganizations = async () => {
            try {
                setLoading(true);
                setError(null);

                const storedUser = JSON.parse(localStorage.getItem('user'));
                const token = storedUser?.token;

                if (!token) {
                    throw new Error(t('general.noAuthToken'));
                }

                const response = await axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/organizations`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                console.log(t('home.fetchedOrganizationsLog'), response.data);
                setOrganizations(response.data);
            } catch (error) {
                console.error(t('home.fetchErrorLog'), error.response || error.message);
                setError(error.response?.data?.error || t('home.fetchError'));
            } finally {
                setLoading(false);
            }
        };

        if (user) {
            fetchOrganizations();
        }
    }, [user, t]);

    if (loading) return <p>{t('home.loading')}</p>;
    if (error) return <p>{t('home.error')}: {error}</p>;

    if (organizations.length === 0) {
        return (
            <div className="bg-dafauna-background  text-dafauna-darkText p-8">
                <p className="text-lg font-bold capitalize">{t('home.greeting', { name: user.name })} 👏</p>
                <hr className="my-4 border-dafauna-primary" />
                <div className="flex flex-col items-center justify-center h-64">
                    <h2 className="text-lg font-bold">{t('home.noOrganizationsMessage')}</h2>
                    <Link to="/create-first-pet" className="add-buddy-icon">
                        <MdOutlinePets />
                        <span className="plus-symbol text-dafauna-darkText">+</span>
                    </Link>
                </div>
            </div>
        );
    } if (organizations.length === 1) {
        const orgId = organizations[0].organizationId._id;
        return (
            <div className="bg-dafauna-background text-dafauna-darkText p-8">
                <div className="home-actions flex justify-between items-center gap-8 mb-5">
                    <p className="text-lg font-bold capitalize">{t('home.greeting', { name: user.name })} 👏</p>
                    <Link to="/create-first-pet" className="house-icon">
                        <BsFillHouseAddFill />
                    </Link>
                </div>
                <hr className="my-4 border-dafauna-primary" />
                <PetList orgId={orgId} />
            </div>
        );
    } else {
        return (
            <div className="bg-dafauna-background text-dafauna-darkText p-8">
                <div className="home-actions flex justify-between items-center gap-8 mb-5">
                    <p className="text-lg font-bold capitalize">{t('home.greeting', { name: user.name })} 👏</p>
                    <Link to="/create-first-pet" className="house-icon">
                        <BsFillHouseAddFill />
                    </Link>
                </div>
                <hr className="my-4 border-dafauna-primary" />
                <OrganizationList organizations={organizations} />
            </div>
        );
    }
};

export default Home;